export const FREQUENT_QUESTIONS_URL =
  '?utm_source=Website&utm_medium=Menu%20home%20superior_Centro%20de%20ayuda&utm_campaign=Centro%20de%20ayuda&artid=aeswm01884'
